import ms20 from '../public/ms20.jpg';
import kitten from '../public/kitten.jpg';
import rolandjuno6 from '../public/rolandjuno6.jpg';

const synths = [
    {
        name: 'Korg MS-20',
        image: ms20,
        polyphony: 'monophonic',
        year: '1978',
        href: 'http://www.vintagesynth.com/korg/ms20.php'

    },
    {
        name: 'Octave The Kitten',
        image: kitten,
        polyphony: 'monophonic',
        year: '1981',
        href: 'http://www.vintagesynth.com/misc/octavekit.php'
    },
    {
        name: 'Roland Juno-6',
        image: rolandjuno6,
        polyphony: 'polyphonic',
        year: '1982',
        href: 'http://www.vintagesynth.com/roland/juno6.php'
    }
];

export default synths;
